import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {User} from "../DB/users/@User";

const MTClass = User;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		updates: DeriveJSONSchema(MTClass, {includeOnly: ["displayName", "permissionGroups"], makeOptional_all: true}),
	}),
})
export class UpdateUser extends Command<{id: string, updates: Partial<MT>}, {}> {}

export const EffectGroup_values = ["sounds", "shakes", "lights", "scripts"] as const;
export type EffectGroup = typeof EffectGroup_values[number];
export const ContentGroup_values = ["scenes", "entities"] as const;
export type ContentGroup = typeof ContentGroup_values[number];
export type TagTargetGroup = EffectGroup|ContentGroup;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$entityGroup: {type: "string"},
		$entityID: {type: "string"},
		$entityTags: {items: {type: "string"}},
	}),
})
export class SetUserEntityTags extends Command<{entityGroup: TagTargetGroup, entityID: string, entityTags: string[]}, {}> {
	/*oldData: MainType;
	newData: MainType;
	Validate() {
		const {entityGroup, entityID, entityTags} = this.payload;
		AssertV(this.userInfo != null, "User must be signed in.");
		this.oldData = GetUser.NN(this.userInfo!.id);
		this.newData = {...this.oldData, entityTags: Clone(this.oldData.entityTags ?? {})};
		DeepSet(this.newData.entityTags, `${entityGroup}/${entityID}`, entityTags, "/", true);
		AssertValidate(MTName, this.newData, `New ${MTName.toLowerCase()}-data invalid`);
	}

	DeclareDBUpdates(db: DBHelper) {
		const {} = this.payload;
		db.set(dbp`users/${this.userInfo!.id}`, this.newData);
	}*/
}